import { createFileRoute } from '@tanstack/react-router'

import { AnalyticsScreen } from '../../components/analytics/Analytics'

export const Route = createFileRoute('/app/analytics')({
  component: AnalyticsScreen,
})
